module.exports = __webpack_public_path__ + "img/zhaoshang.159d5e8b.png";